// extracted by css-extract-rspack-plugin
export default {"logoRoot":"MxGJF0WMgkQIBDfV","logoRow":"VY7pqKAnz9oK89AZ","iconColumn":"ntrfEDOUEsnjnSAR"};